import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    label: string;
    value: string;
  }[];
}
export function Select({
  label,
  error,
  options,
  className = '',
  ...props
}: SelectProps) {
  return <div className="w-full" data-id="element-179">
      {label && <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-180">
          {label}
        </label>}
      <div className="relative" data-id="element-181">
        <select className={`appearance-none block w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-sm shadow-sm placeholder-gray-400
          focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-50 disabled:text-gray-500 ${className}`} {...props} data-id="element-182">
          {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-183">
              {opt.label}
            </option>)}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500" data-id="element-184">
          <ChevronDownIcon className="h-4 w-4" data-id="element-185" />
        </div>
      </div>
      {error && <p className="mt-1 text-xs text-red-600" data-id="element-186">{error}</p>}
    </div>;
}